<template>
  <div class="loadingView" v-if="loadingForm">
    <LoadingList v-model="loadingForm" text="Carregando dados." />
  </div>
  <div v-else>
    <RequiredFieldsMessage :cmeTerms="false" />
    <b-row>
      <b-col v-for="(item, index) in filteredQuestions" :key="index" md="12">
        <b-form-group class="group-radio">
          <label>
            <strong>{{ index + 1 }}</strong> - {{ item.text }}
            <span class="required red">*</span>
          </label>
          <div class="radio-inline">
            <b-form-radio-group
              required
              v-model="value[item.model]"
              :options="options.yesNo"
              :name="item.model + value.enrollment_id"
              :id="item.model + value.enrollment_id"
            />
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingList from "@/components/LoadingList.vue";
import RequiredFieldsMessage from "@/components/RequiredFieldsMessage.vue";

export default {
  name: "Authorizations",
  components: {
    LoadingList,
    RequiredFieldsMessage,
  },
  props: {
    value: Object,
    enrollmentMeta: Object,
  },

  data() {
    return {
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      emCycles: [4, 5],
      fundamentalCycles: [1, 2, 3, 9, 10],
      loadingForm: true,
      options: {
        yesNo: [
          { text: "Sim", value: true },
          { text: "Não", value: false },
        ],
      },
      questions: [
        {
          text: "Fica o aluno antecipadamente autorizado, independentemente de permissão específica, a participar de excursões — parte integrante do projeto pedagógico desta escola — desde que realizadas dentro do horário normal de aulas e dentro dos limites do município.",
          model: "excursion",
          condition: () => true,
        },
        {
          text: "Fica o aluno autorizado a tomar banho de ducha/mangueira independentemente de autorização específica.",
          model: "shower",
          condition: () => true,
        },
        {
          text: "Fica o aluno, matriculado no Ensino Médio, autorizado a sair desacompanhado das dependências da Escola da Serra durante o horário de recreio.",
          model: "leave_school_break",
          condition: (ctx) =>
            ctx.rdaUnit != "POUSO_ALEGRE" &&
            ctx.emCycles.includes(ctx.currentCycle),
        },
      ],
    };
  },

  computed: {
    currentCycle() {
      return this.value.cycle_id || this.enrollmentMeta?.EnrollmentStudent?.cycle_id;
    },
    filteredQuestions() {
      return this.questions.filter((q) => q.condition(this));
    },
    enrollment_id() {
      return this.$route.params.id;
    },
  },

  mounted() {
    this.defineToFalseFields();
  },

  methods: {
    defineToFalseFields() {
      this.value.leave_school_lunch = false;
      this.value.leave_school_antecipated = false;

      if (
        !this.emCycles.includes(this.currentCycle) ||
        this.rdaUnit === "POUSO_ALEGRE"
      ) {
        this.value.leave_school_break = false;
      }
      this.loadingForm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
  font-size: 14px;
  font-weight: bold;
}
</style>
